import DOMPurify from "dompurify";

export function setRawHtml(html) {
    const sanitizedHtml = { __html: DOMPurify.sanitize(html, { ADD_ATTR: ["target"] }) };
    return { dangerouslySetInnerHTML: sanitizedHtml };
}
